import axios from "axios";
import { BASE_URL } from "./type";

export function login(data) {
  return axios.post(BASE_URL + "login", data);
}

export function register(data) {
  return axios.post(BASE_URL + "register", data);
}

export function forgotPassword(data) {
  return axios.post(BASE_URL + "forgot-password", data);
}

export function resetPassword(id, data) {
  return axios.post(BASE_URL + "reset-password/" + id, data);
}

export function verifyEmail(path) {
  if (process.env.NODE_ENV === "development") {
    let url = new URL(path);
    return axios.get("http://127.0.0.1:8003" + url.pathname + url.search);
  }
  // In production use the signed URL as-is — replacing the hostname breaks the signature
  return axios.get(path);
}

export function resendEmail(data) {
  return axios.post(BASE_URL + "email/resend", data);
}

export function logout() {
  return axios.post(BASE_URL + "logout");
}
